<template>
  <div class="cont">
      <div class="banner">
          <div class="title">
              <span class="line"></span>
              <span class="text">高端服务律师驻场</span>
              <span class="line"></span>
              <p>专业领域精准定位</p>
              <p class="newP">适用于大中型企业</p>
              <el-button @click="Tocontact" style="margin-top: 55px" type="primary">立即咨询</el-button>
          </div>

      </div>
  </div>
</template>

<script>
export default {
    name: 'Cont',
    data () {
        return {
            isShow:true,
            InpList:{
                iname:'',
                iphone:'',
                itxt:''
            }
        }
    },
    methods:{
        Tocontact(){
            this.isShow = !this.isShow;
            this.$emit('childByBtn', this.isShow);
            // console.log("111");
            this.isShow = !this.isShow;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .cont{
        width: 100%;
        .banner{
            display: flex;
            justify-content: center; /* 水平居中 */
            align-items: center;     /* 垂直居中 */
            background: url("../assets/img/banner.png") no-repeat;
            background-size: cover;
            width: 100%;
            height: 600px;
            .title{
                width: 400px;
                height: 220px;
                /*background: yellow;*/
                text-align: center;
                .el-button{
                    width:150px;
                    height:50px;
                    border-radius:8px;
                    color:white;
                    background:rgb(50,150,250);
                    font-size:14px;
                    font-weight:550;
                }
                .text{
                    color: white;
                    font-size: 18px;
                }
                .line{
                    display:inline-block;
                    width:53px;
                    border-top:1px solid white;
                    vertical-align:5px;
                }
                p{
                    font-size: 40px;
                    margin-top: 28px;
                    color: white;
                }
                .newP{
                    font-size: 18px;
                    margin-top: 28px;
                    color: white;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/cont.vue